/*
 *
 * LanguageProvider reducer
 *
 */
import produce from 'immer';
import { CHANGE_LOCALE } from './constants';
export var initialState = {
    locale: 'en',
};
function languageProviderReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case CHANGE_LOCALE:
                state.locale = action.locale;
                break;
            default:
                break;
        }
    });
}
export default languageProviderReducer;
